<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  components: {},
  data() {
    return {
      // 弹窗内高度自适应，交给 Modal 的滚动条处理
      isCalculateHeight: false,
    };
  },
  async mounted() {
    await this.getConfigList('add-list');
  },

  methods: {

  },
};
</script>
